// VI UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Căn hộ & Khách sạn',
  'site.currency': 'Tiền tệ',
  'site.language': 'Ngôn ngữ',
  'site.currencySelector': 'Chọn tiền tệ',
  'site.languageSelector': 'Chọn ngôn ngữ',
  'site.menu': 'Menu',
  'site.signIn': 'Đăng nhập',
  'site.signOut': 'Đăng xuất',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Mở menu',
  'site.footer.copyright': 'Mọi quyền được bảo lưu.',
  'site.footer.manageBooking': 'Quản lý đặt phòng',
  'site.footer.terms': 'Điều khoản & Điều kiện',
  'site.footer.privacy': 'Chính sách Bảo mật',
  'site.trust.bestPrice': 'Đảm bảo giá tốt nhất',
  'site.trust.bestPriceDesc': 'Nhận mức giá ưu đãi nhất.',
  'site.trust.flexibleBooking': 'Đặt phòng linh hoạt',
  'site.trust.flexibleBookingDesc': 'Dễ dàng thay đổi & hủy.',
  'site.trust.securePayments': 'Thanh toán an toàn',
  'site.trust.securePaymentsDesc': 'Thanh toán đáng tin & an toàn.',
  'site.trust.localSupport': 'Hỗ trợ tại chỗ',
  'site.trust.localSupportDesc': 'Chúng tôi luôn sẵn sàng hỗ trợ.',
  'home.heroTitle': 'Tìm chỗ ở hoàn hảo cho bạn',
  'home.inAustralia': 'tại Australia',
  'home.heroSubtitle': 'Căn hộ và khách sạn cho mọi kỳ nghỉ',
  'home.errorLoading': 'Không thể tải danh sách chỗ ở.',
  'home.noPropertiesTitle': 'Hiện tại không có chỗ ở nào.',
  'home.noPropertiesDescription': 'Hãy thử tìm kiếm điểm đến để khám phá chỗ ở hiện có.',
  'home.exploreStays': 'Khám phá chỗ ở',
  'home.property': 'chỗ ở',
  'home.property_one': 'chỗ ở',
  'home.property_other': 'chỗ ở',
  'home.properties': 'chỗ ở',
  'home.foundInAustralia': 'tìm thấy tại Australia',
  'search.errorLoading': 'Không thể tải thông tin phòng trống. Vui lòng thử lại.',
  'search.noResults': 'Không có chỗ ở nào phù hợp với tiêu chí tìm kiếm.',
  'search.mapFollow': 'Tìm kiếm khi tôi di chuyển bản đồ',
  'search.chooseLocationTitle': 'Chọn địa điểm',
  'search.chooseLocationDescription': 'Vui lòng chọn điểm đến trước khi tìm chỗ ở.',
  'search.chooseDatesTitle': 'Chọn ngày của bạn',
  'search.pastCheckIn': 'Ngày nhận phòng không được ở quá khứ.',
  'search.checkOutAfterCheckIn': 'Ngày trả phòng phải sau ngày nhận phòng.',
  'search.property': 'chỗ ở',
  'search.property_one': 'chỗ ở',
  'search.property_other': 'chỗ ở',
  'search.properties': 'chỗ ở',
  'search.found': 'tìm thấy',
  'widget.where': 'Địa điểm',
  'widget.location': 'Địa điểm',
  'widget.checkInOut': 'Nhận phòng / Trả phòng',
  'widget.guests': 'Khách',
  'widget.rooms': 'Phòng',
  'widget.promoCode': 'Mã khuyến mãi',
  'widget.promoPlaceholderCompact': 'Nhập mã (tùy chọn)',
  'widget.promoPlaceholder': 'Tùy chọn',
  'widget.search': 'Tìm kiếm',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Người lớn',
  'widget.adults': 'Người lớn',
  'widget.child': 'Trẻ em',
  'widget.children': 'Trẻ em',
  'widget.decreaseAdults': 'Giảm số người lớn',
  'widget.increaseAdults': 'Tăng số người lớn',
  'widget.decreaseChildren': 'Giảm số trẻ em',
  'widget.increaseChildren': 'Tăng số trẻ em',
  'widget.room': 'Phòng',
  'widget.adultOption': '{count} người lớn',
  'widget.adultOption_one': '{count} người lớn',
  'widget.adultOption_other': '{count} người lớn',
  'widget.childOption': '{count} trẻ em',
  'widget.childOption_one': '{count} trẻ em',
  'widget.childOption_other': '{count} trẻ em',
  'widget.roomOption': '{count} phòng',
  'widget.roomOption_one': '{count} phòng',
  'widget.roomOption_other': '{count} phòng',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Không thể tải địa điểm. Vui lòng thử lại.',
  'widget.searchAria': 'Tìm kiếm phòng trống',
  'widget.dateErrorRequired': 'Vui lòng chọn cả ngày nhận và trả phòng.',
  'widget.dateErrorPast': 'Ngày nhận phòng không được ở quá khứ.',
  'widget.dateErrorRange': 'Ngày trả phòng phải sau ngày nhận phòng.',
  'widget.dateRange.placeholder': 'Chọn ngày nhận & trả phòng',
  'widget.dateRange.selectCheckout': 'Chọn ngày trả phòng',
  'widget.dateRange.aria.checkIn': 'Nhận phòng',
  'widget.dateRange.aria.checkOut': 'Trả phòng',
  'widget.dateRange.aria.picker': 'Bộ chọn khoảng ngày nhận / trả phòng',
  'widget.dateRange.previousMonth': 'Tháng trước',
  'widget.dateRange.nextMonth': 'Tháng sau',
  'widget.dateRange.selectCheckIn': 'Chọn ngày nhận phòng',
  'widget.dateRange.selectCheckOut': 'Chọn ngày trả phòng',
  'widget.dateRange.resetToday': 'Đặt lại về hôm nay',
  'widget.dateRange.done': 'Xong',
  'property.heroAlt': 'Ảnh chính chỗ ở',
  'property.fallbackName': 'Chỗ ở được chọn từ {site}',
  'property.chooseRoom': 'Chọn phòng của bạn',
  'property.filterBy': 'Lọc theo:',
  'property.filterAll': 'Tất cả phòng',
  'property.filterStudios': 'Căn studio',
  'property.filter1Bed': '1 phòng ngủ',
  'property.filter2Bed': '2 phòng ngủ',
  'property.filterApartments': 'Căn hộ',
  'property.sortBy': 'Sắp xếp theo:',
  'property.sortRecommended': 'Đề xuất',
  'property.sortPriceLow': 'Giá: Thấp đến cao',
  'property.sortPriceHigh': 'Giá: Cao đến thấp',
  'property.errorLoading': 'Không thể tải thông tin phòng trống. Vui lòng thử lại.',
  'property.noRooms': 'Không có phòng trống',
  'property.noRoomsDescription': 'Hãy thử ngày khác hoặc số lượng khách khác.',
  'property.totalForNights': 'Tổng cộng cho {nights} đêm',
  'property.perNight': 'mỗi đêm',
  'property.night': 'đêm',
  'property.night_one': 'đêm',
  'property.night_other': 'đêm',
  'property.nights': 'đêm',
  'property.freeCancellation': 'Hủy miễn phí',
  'property.selectRoom': 'Chọn phòng',
  'property.selected': 'Đã chọn',
  'property.continue': 'Tiếp tục',
  'property.previousPhoto': 'Ảnh trước',
  'property.nextPhoto': 'Ảnh sau',
  'property.addToWishlist': 'Thêm vào yêu thích',
  'property.popularChoice': 'Lựa chọn phổ biến',
  'property.showMore': 'Xem thêm',
  'property.showLess': 'Thu gọn',
  'property.maxOccupancy': 'Sức chứa tối đa:',
  'property.size': 'Diện tích:',
  'property.bedType': 'Loại giường:',
  'property.roomAmenities': 'Tiện nghi phòng',
  'property.showMoreAmenities': '+{count} nữa',
  'property.guests': 'Khách',
  'property.adults': 'Người lớn',
  'property.children': 'Trẻ em',
  'property.onlyRoomsLeft': 'Chỉ còn {count} phòng',
  'property.onlyRoomsLeft_one': 'Chỉ còn {count} phòng',
  'property.onlyRoomsLeft_other': 'Chỉ còn {count} phòng',
  'property.lastBookedMinutes': 'Đặt phòng lần cuối {count} phút trước',
  'property.lastBookedMinutes_one': 'Đặt phòng lần cuối {count} phút trước',
  'property.lastBookedMinutes_other': 'Đặt phòng lần cuối {count} phút trước',
  'property.lastBookedHours': 'Đặt phòng lần cuối {count} giờ trước',
  'property.lastBookedHours_one': 'Đặt phòng lần cuối {count} giờ trước',
  'property.lastBookedHours_other': 'Đặt phòng lần cuối {count} giờ trước',
  'property.lastBookedDays': 'Đặt phòng lần cuối {count} ngày trước',
  'property.lastBookedDays_one': 'Đặt phòng lần cuối {count} ngày trước',
  'property.lastBookedDays_other': 'Đặt phòng lần cuối {count} ngày trước',
  'property.checkInTime': 'Nhận phòng {time}',
  'property.checkOutTime': 'Trả phòng {time}',
  'property.compare': 'So sánh',
  'property.taxesIncluded': 'mỗi đêm đã bao gồm thuế & phí',
  'property.chooseRate': 'Chọn mức giá',
  'property.yourSelection': 'Lựa chọn của bạn',
  'property.aboutRoom': 'Về phòng này',
  'property.roomDetails': 'Chi tiết phòng',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Quay lại danh sách phòng',
  'property.standardRate': 'Giá tiêu chuẩn',
  'property.noPromotion': 'Không có khuyến mãi cho mức giá này.',
  'property.youSave': 'Bạn tiết kiệm ({percent}%) - {amount}',
  'property.inclusions': 'Bao gồm:',
  'property.viewAllPhotos': 'Xem tất cả ảnh',
  'property.seeOnMap': 'Xem trên bản đồ',
  'room.perNight': 'đêm',
  'room.sleeps': 'Sức chứa',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'còn trống',
  'room.select': 'Chọn',
  'room.selected': 'Đã chọn',
  'card.viewAvailability': 'Xem phòng trống',
  'card.from': 'Từ',
  'card.night': 'đêm',
  'card.checkAvailability': 'Kiểm tra phòng trống',
  'card.saveToFavourites': 'Lưu vào yêu thích',
  'card.ratingExcellent': 'Xuất sắc',
  'card.ratingVeryGood': 'Rất tốt',
  'card.ratingGood': 'Tốt',
  'card.ratingGuest': 'Đánh giá của khách',
  'guest.stepChooseRoom': 'Chọn phòng',
  'guest.stepGuestDetails': 'Thông tin khách',
  'guest.stepPayment': 'Thanh toán',
  'guest.stepConfirmation': 'Xác nhận',
  'guest.title': 'Nhập thông tin khách',
  'guest.subtitle': 'Vui lòng cung cấp thông tin của bạn.',
  'guest.firstName': 'Tên',
  'guest.lastName': 'Họ',
  'guest.email': 'Email',
  'guest.emailHint': 'Xác nhận đặt phòng sẽ được gửi đến email này.',
  'guest.country': 'Quốc gia',
  'guest.selectCountry': 'Chọn quốc gia',
  'guest.searchCountry': 'Tìm kiếm quốc gia…',
  'guest.loadingCountries': 'Đang tải quốc gia…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Mã bưu điện',
  'guest.phone': 'Số điện thoại',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Nhập số điện thoại',
  'guest.address': 'Địa chỉ',
  'guest.city': 'Thành phố',
  'guest.specialRequests': 'Yêu cầu đặc biệt (tùy chọn)',
  'guest.specialRequestsPlaceholder': 'Bạn có yêu cầu đặc biệt nào không?',
  'guest.termsPrefix': 'Bằng cách hoàn tất đặt phòng, tôi đồng ý với',
  'guest.terms': 'Điều khoản & Điều kiện',
  'guest.termsAnd': 'và',
  'guest.privacy': 'Chính sách Bảo mật',
  'guest.termsSuffix': ', và tôi chấp nhận các điều kiện đặt phòng.',
  'guest.marketingOptOut': 'Tôi không muốn nhận thông tin tiếp thị.',
  'guest.cardVerify':
    'Một khoản xác minh thẻ tạm thời 1 {currency} sẽ được giữ. Bạn sẽ không bị tính phí ngay bây giờ.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Thanh toán sẽ được thu tại chỗ ở.',
  'guest.noRoomsSelected': 'Chưa chọn phòng nào.',
  'guest.noPropertySelected': 'Chưa chọn chỗ ở nào.',
  'guest.paymentStillLoading': 'Các tùy chọn thanh toán vẫn đang tải. Vui lòng thử lại sau.',
  'guest.submitProcessing': 'Đang xử lý…',
  'guest.submitVerifyCard': 'Xác minh thẻ và xác nhận đặt phòng',
  'guest.submitConfirm': 'Xác nhận đặt phòng',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Thanh toán',
  'payment.method': 'Phương thức thanh toán',
  'payment.cardDetailsHint':
    'Nhập thông tin thẻ một cách an toàn bên dưới. Thông tin thẻ của bạn được mã hóa và không bao giờ chạm đến máy chủ của chúng tôi.',
  'payment.loadingForm': 'Đang tải biểu mẫu thanh toán…',
  'payment.formUnavailable': 'Biểu mẫu thanh toán không khả dụng.',
  'payment.acceptTerms': 'Tôi chấp nhận điều khoản, điều kiện và chính sách hủy.',
  'payment.payNow': 'Thanh toán ngay',
  'payment.processing': 'Đang xử lý…',
  'payment.noRoomsSelected': 'Chưa chọn phòng nào.',
  'payment.redirecting': 'Đang chuyển hướng đến trang thanh toán an toàn…',
  'payment.notConfigured': 'Quickstream chưa được cấu hình cho chỗ ở này.',
  'payment.noScript': 'Không thể tải dịch vụ thanh toán Quickstream. Vui lòng làm mới trang.',
  'payment.formNotLoaded': 'Biểu mẫu thanh toán chưa được tải. Vui lòng làm mới trang.',
  'payment.cardDetails': 'Thanh toán thất bại. Vui lòng kiểm tra thông tin thẻ.',
  'payment.tokenizationFailed': 'Mã hóa thẻ thất bại. Vui lòng thử lại.',
  'payment.failed': 'Thanh toán thất bại.',
  'payment.statusResult': 'Trạng thái thanh toán: {status}. Vui lòng thử lại.',
  'confirmation.loading': 'Đang tải đặt phòng của bạn…',
  'confirmation.notFound': 'Không tìm thấy đặt phòng. Vui lòng kiểm tra mã đặt phòng và thử lại.',
  'confirmation.errorGeneric': 'Không thể xác nhận đặt phòng của bạn. Vui lòng liên hệ hỗ trợ.',
  'confirmation.errorLoadDetails': 'Không thể tải chi tiết đặt phòng.',
  'confirmation.couldNotComplete': 'Chúng tôi không thể hoàn tất thanh toán của bạn',
  'confirmation.startNew': 'Bắt đầu đặt phòng mới',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'Không tìm thấy phiên thanh toán. Vui lòng liên hệ hỗ trợ.',
  'confirmation.paymentStateInvalid':
    'Thanh toán không ở trạng thái hợp lệ để hoàn tất. Vui lòng bắt đầu lại.',
  'confirmation.paymentFailedDeclined':
    'Không thể hoàn tất thanh toán của bạn. Vui lòng kiểm tra thông tin thẻ và thử lại, hoặc sử dụng phương thức thanh toán khác.',
  'confirmation.paymentTimeout': 'Thanh toán mất quá nhiều thời gian. Vui lòng thử lại.',
  'confirmation.paymentGatewayUnavailable':
    'Hệ thống thanh toán tạm thời không khả dụng. Vui lòng thử lại sau ít phút.',
  'confirmation.paymentUnknown': 'Không thể xác nhận thanh toán: {message}.',
  'confirmation.paymentGenericError':
    'Không thể xác nhận thanh toán. Vui lòng thử lại hoặc liên hệ hỗ trợ.',
  'summary.title': 'Tóm tắt đặt phòng của bạn',
  'summary.yourBooking': 'Tóm tắt đặt phòng của bạn',
  'summary.noRoomsSelected': 'Chưa chọn phòng nào.',
  'summary.checkIn': 'NHẬN PHÒNG',
  'summary.checkOut': 'TRẢ PHÒNG',
  'summary.lengthOfStay': 'Thời gian lưu trú',
  'summary.guests': 'Khách',
  'summary.nights': '{nights} đêm',
  'summary.nights_one': '{nights} đêm',
  'summary.nights_other': '{nights} đêm',
  'summary.totalForNights': 'Tổng cộng cho {nights} đêm',
  'summary.includingTaxes': 'Đã bao gồm thuế & phí',
  'summary.discount': 'Tiết kiệm {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Đặt phòng đã được xác nhận!',
  'detail.received': 'Đã nhận đặt phòng',
  'detail.referenceIntro': 'Mã đặt phòng của bạn là',
  'detail.reservationId': 'Mã đặt phòng:',
  'detail.processing':
    'Đặt phòng của bạn đang được xử lý. Bạn sẽ nhận được email xác nhận sau khi thanh toán được xác nhận.',
  'detail.guest': 'Khách',
  'detail.rooms': 'Phòng',
  'detail.night': 'đêm',
  'detail.nights': 'đêm',
  'detail.adult': 'người lớn',
  'detail.adults': 'người lớn',
  'detail.child': 'trẻ em',
  'detail.infant': 'trẻ sơ sinh',
  'detail.priceBreakdown': 'Chi tiết giá',
  'detail.subtotal': 'Tạm tính',
  'detail.taxes': 'Thuế',
  'detail.fees': 'Phí',
  'detail.discounts': 'Giảm giá',
  'detail.surcharge': 'Phụ phí thẻ',
  'detail.grandTotal': 'Tổng cộng',
  'priceBreakdown.roomSubtotal': 'Tạm tính phòng',
  'priceBreakdown.total': 'Tổng cộng',
  'detail.deposit': 'Đặt cọc',
  'detail.depositDueBy': 'đến hạn vào',
  'detail.arrival': 'nhận phòng',
  'detail.specialRequests': 'Yêu cầu đặc biệt',
  'detail.backToHome': 'Về trang chủ',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Thử lại',
  'shared.close': 'Đóng',
  'shared.back': 'Quay lại',
  'shared.previous': 'Trước',
  'shared.next': 'Tiếp',
  'validation.firstNameRequired': 'Vui lòng nhập tên',
  'validation.lastNameRequired': 'Vui lòng nhập họ',
  'validation.emailRequired': 'Vui lòng nhập email hợp lệ',
  'validation.phoneRequired': 'Vui lòng nhập số điện thoại',
  'validation.addressRequired': 'Vui lòng nhập địa chỉ',
  'validation.cityRequired': 'Vui lòng nhập thành phố',
  'validation.countryRequired': 'Vui lòng chọn quốc gia',
  'validation.postalCodeRequired': 'Vui lòng nhập mã bưu điện',
  'error.pmsUnavailable':
    'Rất tiếc, phòng này không còn trống cho ngày bạn chọn. Vui lòng quay lại và chọn ngày khác hoặc phòng khác.',
  'error.pmsSyncError':
    'Chúng tôi không thể kết nối với hệ thống chỗ ở. Vui lòng thử lại sau ít phút.',
  'error.paymentNotConfigured':
    'Thanh toán chưa được cấu hình cho chỗ ở này. Vui lòng chọn chỗ ở khác hoặc liên hệ hỗ trợ.',
  'error.paymentStartFailed': 'Đã xảy ra lỗi khi bắt đầu thanh toán. Vui lòng thử lại.',
  'error.bookingFailed': 'Đặt phòng thất bại. Vui lòng thử lại.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Đặt chỗ ở của bạn',
  'site.title.suffix': 'Căn hộ và Khách sạn',
  'site.title.home': 'Trang chủ',
  'site.title.search': 'Tìm kiếm',
  'site.title.property': 'Chỗ ở',
  'site.title.room': 'Phòng',
  'site.title.guestDetails': 'Thông tin khách',
  'site.title.payment': 'Thanh toán',
  'site.title.confirmation': 'Đặt phòng đã xác nhận',
  'site.title.bookingLookup': 'Tìm đặt phòng',
  'site.title.bookingDetails': 'Chi tiết đặt phòng',
  'site.title.cancellation': 'Hủy đặt phòng',
  'site.title.reservationDetail': 'Chi tiết đặt phòng',
  'site.title.signIn': 'Đăng nhập',
  'site.title.signUp': 'Đăng ký',
  'site.title.notFound': 'Không tìm thấy trang',
  'notFound.title': 'Không tìm thấy trang',
  'notFound.message': 'Trang bạn đang tìm không tồn tại.',
  'notFound.backHome': 'Về trang chủ',
  'home.heroAlt': 'Đường chân trời thành phố Australia',
  'home.featuredProperties': 'Chỗ ở nổi bật',
  'home.popularDestinations': 'Điểm đến phổ biến',
  'common.reviews': '{count} đánh giá',
  'common.reviews_one': '{count} đánh giá',
  'common.reviews_other': '{count} đánh giá',
  'common.loading': 'Đang tải',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'trên',
  'common.select': 'Chọn…',
  'common.search': 'Tìm kiếm…',
  'common.selectLocation': 'Chọn địa điểm',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Không có tùy chọn nào',
  'common.code': 'Mã',
  'common.searchCode': 'Tìm kiếm mã…',
  'filter.title': 'Bộ lọc',
  'filter.price': 'Giá',
  'filter.priceMinimum': 'Tối thiểu',
  'filter.priceMaximum': 'Tối đa',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Loại chỗ ở',
  'filter.propertyType.hotel': 'Khách sạn',
  'filter.propertyType.apartment': 'Căn hộ',
  'filter.propertyType.resort': 'Khu nghỉ dưỡng',
  'filter.amenities': 'Tiện nghi',
  'filter.amenity.pool': 'Hồ bơi',
  'filter.amenity.parking': 'Bãi đậu xe',
  'filter.amenity.breakfast': 'Bao gồm ăn sáng',
  'filter.rating': 'Xếp hạng',
  'filter.rating.any': 'Mọi xếp hạng',
  'filter.rating.5': '5 sao',
  'filter.rating.4': '4 sao trở lên',
  'filter.rating.3': '3 sao trở lên',
  'filter.more': 'Thêm',
  'filter.more.freeCancellation': 'Hủy miễn phí',
  'filter.more.payAtProperty': 'Thanh toán tại chỗ ở',
  'filter.clear': 'Xóa',
  'filter.apply': 'Áp dụng bộ lọc',
  'card.reviews_one': 'đánh giá',
  'card.reviews_other': 'đánh giá',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Độ tuổi từ 0 - 12',
  'auth.orContinueWith': 'Hoặc tiếp tục với',
  'auth.signIn.title': 'Đăng nhập vào tài khoản của bạn',
  'auth.signIn.subtitle':
    'Chào mừng trở lại! Đăng nhập để quản lý đặt phòng, xem lưu trú của bạn và tiếp cận ưu đãi độc quyền.',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Nhập địa chỉ email của bạn',
  'auth.emailRequired': 'Vui lòng nhập email.',
  'auth.emailInvalid': 'Vui lòng nhập địa chỉ email hợp lệ.',
  'auth.password': 'Mật khẩu',
  'auth.passwordPlaceholder': 'Nhập mật khẩu của bạn',
  'auth.createPasswordPlaceholder': 'Tạo mật khẩu',
  'auth.passwordRequired': 'Vui lòng nhập mật khẩu.',
  'auth.passwordMinLength': 'Mật khẩu phải có ít nhất {min} ký tự.',
  'auth.passwordPattern': 'Mật khẩu phải bao gồm chữ và số.',
  'auth.passwordHint': 'Sử dụng ít nhất {min} ký tự kết hợp chữ, số và ký hiệu.',
  'auth.showPassword': 'Hiển thị mật khẩu',
  'auth.hidePassword': 'Ẩn mật khẩu',
  'auth.keepSignedIn': 'Giữ tôi đăng nhập',
  'auth.forgotPassword': 'Quên mật khẩu?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Đăng nhập',
  'auth.signingIn': 'Đang đăng nhập...',
  'auth.signInError': 'Đăng nhập thất bại. Vui lòng thử lại.',
  'auth.googleError': 'Đăng nhập Google thất bại.',
  'auth.noAccount': 'Bạn chưa có tài khoản?',
  'auth.createAccount': 'Tạo tài khoản',
  'auth.signUp.title': 'Tạo tài khoản của bạn',
  'auth.signUp.subtitle':
    'Tham gia {site} để quản lý đặt phòng, lưu chỗ ở yêu thích và nhận ưu đãi độc quyền.',
  'auth.firstName': 'Tên',
  'auth.firstNamePlaceholder': 'Nhập tên của bạn',
  'auth.firstNameRequired': 'Vui lòng nhập tên.',
  'auth.lastName': 'Họ',
  'auth.lastNamePlaceholder': 'Nhập họ của bạn',
  'auth.lastNameRequired': 'Vui lòng nhập họ.',
  'auth.mobile': 'Số điện thoại di động',
  'auth.mobilePlaceholder': 'Nhập số điện thoại di động của bạn',
  'auth.dialingCode': 'Mã quốc gia',
  'auth.mobileRequired': 'Vui lòng nhập số điện thoại di động.',
  'auth.mobileInvalid': 'Vui lòng nhập số điện thoại di động hợp lệ.',
  'auth.confirmPassword': 'Xác nhận mật khẩu',
  'auth.confirmPasswordPlaceholder': 'Xác nhận mật khẩu của bạn',
  'auth.termsAgree': 'Tôi đồng ý với',
  'auth.termsRequired': 'Bạn phải đồng ý với Điều khoản & Điều kiện và Chính sách Bảo mật.',
  'auth.marketingConsent': 'Tôi muốn nhận ưu đãi độc quyền và cảm hứng du lịch từ {site}',
  'auth.signUpError': 'Không thể tạo tài khoản. Vui lòng thử lại.',
  'auth.signUp': 'Đăng ký',
  'auth.creatingAccount': 'Đang tạo tài khoản...',
  'auth.createAccountButton': 'Tạo tài khoản',
  'auth.alreadyHaveAccount': 'Bạn đã có tài khoản?',
  'auth.passwordMismatch': 'Mật khẩu không khớp.',
  'pricing.title': 'Tóm tắt giá',
  'pricing.noRoomsSelected': 'Chưa chọn phòng nào. Vui lòng quay lại và chọn phòng.',
  'pricing.backToAvailability': 'Quay lại phòng trống',
  'pricing.continue': 'Tiếp tục đến thông tin khách',
  'property.youSavePercent': 'Bạn tiết kiệm ({percent}%)',
  'property.includingTaxesFees': '(đã bao gồm thuế & phí)',
  'map.zoomIn': 'Phóng to',
  'map.zoomOut': 'Thu nhỏ',
  'map.viewFullMap': 'Xem bản đồ đầy đủ',
  'booking.progress': 'Tiến trình đặt phòng',
  'reservationDetail.resetAria': 'Đặt lại trạng thái đặt phòng',
  'bookingLookup.title': 'Tìm đặt phòng của bạn',
  'bookingLookup.description':
    'Nhập mã đặt phòng và email để xem, thay đổi hoặc hủy đặt phòng của bạn.',
  'bookingLookup.bookingReference': 'Mã đặt phòng',
  'bookingLookup.placeholder': 'vd: SYD-260815-0001',
  'bookingLookup.lookingUp': 'Đang tìm…',
  'bookingLookup.findBooking': 'Tìm đặt phòng',
  'bookingLookup.notFound':
    'Không tìm thấy đặt phòng. Hãy thử BK-2026-001, alex.morgan@example.com và Morgan.',
  'cancellation.title': 'Hủy đặt phòng',
  'cancellation.property': 'Chỗ ở',
  'cancellation.details': 'Chi tiết hủy',
  'cancellation.penalty': 'Phí hủy',
  'cancellation.refund': 'Số tiền hoàn lại',
  'cancellation.totalPaid': 'Tổng đã thanh toán:',
  'cancellation.reasonLabel': 'Lý do hủy (tùy chọn)',
  'cancellation.understand': 'Tôi hiểu hành động này không thể hoàn tác.',
  'cancellation.cancelledDemo':
    'Đặt phòng của bạn đã bị hủy trong bản demo này. Số tiền hoàn lại: {{refundAmount}}.',
  'cancellation.confirm': 'Xác nhận hủy',
  'cancellation.notFound': 'Không tìm thấy đặt phòng.',
  'bookingDetails.title': 'Chi tiết đặt phòng',
  'bookingDetails.notFound': 'Không tìm thấy đặt phòng.',
  'bookingDetails.checkIn': 'Nhận phòng:',
  'bookingDetails.checkOut': 'Trả phòng:',
  'bookingDetails.rooms': 'Phòng',
  'bookingDetails.guest': 'Khách',
  'bookingDetails.freeCancellationUntil': 'Hủy miễn phí đến {date}',
  'bookingDetails.total': 'Tổng cộng:',
  'reservationDetail.loading': 'Đang tải đặt phòng của bạn…',
  'reservationDetail.noReference': 'Chưa cung cấp mã đặt phòng.',
  'reservationDetail.loadError': 'Không thể tải chi tiết đặt phòng.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Đang tải địa điểm…',
  'common.couldNotLoadLocations': 'Không thể tải địa điểm',
  'common.searchLocationPlaceholder': 'Tìm quốc gia, thành phố hoặc chỗ ở',
  'common.collapse': 'Thu gọn',
  'common.expand': 'Mở rộng',
  'map.loadingGoogle': 'Đang tải Google Map…',
  'map.errorGoogle': 'Không thể tải Google Maps',
  'map.errorMap': 'Không thể tải bản đồ.',
  'map.greatLocation': 'Vị trí tuyệt vời',
  'home.trust.secureBooking': 'Đặt phòng an toàn',
  'home.trust.secureBookingDesc': 'Thông tin của bạn được bảo mật với chúng tôi.',
  'home.trust.bestPrice': 'Đảm bảo giá tốt nhất',
  'home.trust.bestPriceDesc': 'Tìm thấy giá rẻ hơn? Chúng tôi sẽ khớp giá đó.',
  'home.trust.localSupport': 'Hỗ trợ 24/7',
  'home.trust.localSupportDesc': 'Chúng tôi luôn sẵn sàng hỗ trợ bạn.',
  'home.trust.flexibleBooking': 'Linh hoạt',
  'home.trust.flexibleBookingDesc': 'Hủy miễn phí với một số mức giá.',
  'promotion.memberPromo': 'Khuyến mãi thành viên',
  'promotion.save': 'Tiết kiệm',
  'property.memberRate': 'Giá thành viên',
  'property.hideAmenities': 'Ẩn tiện nghi',
  'property.showAllAmenities': 'Hiển thị tất cả tiện nghi',
  'property.chooseRatePromo': 'Chọn mức giá ưu tiên - Giá thành viên mang đến ưu đãi độc quyền!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-giảm {percent}%',
  'gallery.imageAlt': '{title} - hình {current} / {total}',
  'gallery.thumbnailAlt': 'Xem hình {current} / {total}',
  'gallery.previewAlt': 'Xem trước {title}',
  'detail.night_one': 'đêm',
  'detail.night_other': 'đêm',
  'detail.adult_one': 'người lớn',
  'detail.adult_other': 'người lớn',
  'detail.child_one': 'trẻ em',
  'detail.child_other': 'trẻ em',
  'detail.infant_one': 'trẻ sơ sinh',
  'detail.infant_other': 'trẻ sơ sinh',
} as const;
